<template>
  <v-card>
    <v-form v-model="valid" ref="UserInfoForm" @submit.prevent>
      <v-card-title>
        <v-icon>account_circle</v-icon>
        <span class="subtitle-1 font-weight-bold ml-2">User Information</span>
      </v-card-title>
      <v-card-text>
        <v-row v-if="error">
          <v-col cols="12">
            <v-icon left color="error" class="mr-2">announcement</v-icon>
            <span class="error--text">{{ errorMessage }}</span>
          </v-col>
        </v-row>
        <v-text-field
          v-model="userDetails.userName"
          outlined
          prepend-inner-icon="account_box"
          :rules="[required('Full Name')]"
          label=" Full Name"
        ></v-text-field>
        <v-text-field
          v-model="userDetails.email"
          outlined
          label="Email address"
          name="email"
          prepend-inner-icon="mdi-email"
          type="email"
          :rules="[required('Email'), isEmail]"
          validate-on-blur
        ></v-text-field>
        <v-text-field
          v-model="userDetails.password"
          outlined
          :rules="[
            required('Password'),
            maxLength('Password'),
            minLength('Password'),
          ]"
          prepend-inner-icon="lock"
          label="Password"
          type="password"
          v-if="isRegisteringUser || $store.getters.retrieveAnon"
        ></v-text-field>
        <v-text-field
          v-model="userDetails.confirmPassword"
          :rules="[required('Confirm Password'), passwordConfirmationRule]"
          label="Confirm Password"
          outlined
          prepend-inner-icon="lock"
          type="password"
          validate-on-blur
          v-if="isRegisteringUser || $store.getters.retrieveAnon"
        ></v-text-field>
        <v-text-field
          v-model="userDetails.telephone"
          outlined
          prepend-inner-icon="call"
          :rules="[required('Phone Number'), isPhoneNumber]"
          label="Phone Number"
        ></v-text-field>
      </v-card-text>
      <v-card-actions v-if="isRegisteringUser">
        <v-spacer />
        <v-btn
          type="submit"
          color="primary"
          @click.stop="goToNextStep"
          :disabled="!valid"
          >Continue</v-btn
        >
      </v-card-actions>
      <v-card-actions v-else>
        <v-spacer />
        <v-btn
          type="submit"
          color="primary"
          @click.stop="goToNextStep"
          :disabled="!valid"
          >Continue</v-btn
        >
      </v-card-actions>
    </v-form>
  </v-card>
</template>
<script>
import checkPostCode from "@/util/validation/postcode.js";
import checkEmail from "@/util/validation/email.js";
import checkUKTelephone from "@/util/validation/phoneNumber.js";
export default {
  name: "UserInformation",
  props: ["userDetails", "error", "errorMessage"],
  data: () => {
    return {
      valid: false,
      required(fieldName) {
        return (v) => (v && v.length > 0) || `${fieldName} Required`;
      },
      maxLength(fieldName) {
        return (v) =>
          (v && v.length < 25) ||
          `${fieldName} must be less than 25 characters`;
      },
      minLength(fieldName) {
        return (v) =>
          (v && v.length > 3) || `${fieldName} must be more than 3 characters`;
      },
      isEmail: (val) => {
        return checkEmail(val);
      },
      isPostCode: (val) => {
        return checkPostCode(val);
      },
      isPhoneNumber: (val) => {
        return checkUKTelephone(val);
      },
    };
  },
  computed: {
    passwordConfirmationRule() {
      return () =>
        this.userDetails.password === this.userDetails.confirmPassword ||
        "Password must match";
    },

    isCncOnly() {
      return this.$store.state.user.cncOnly == "1";
    },
    cncAddressLine1() {
      return this.$store.state.configs.cnc_address_line_1;
    },
    cncAddressLine2() {
      return this.$store.state.configs.cnc_address_line_2;
    },
    cncAddressLine3() {
      return this.$store.state.configs.cnc_address_line_3;
    },
    cncAddressLine4() {
      return this.$store.state.configs.cnc_address_line_4;
    },
    cncPostcode() {
      return this.$store.state.configs.cnc_postcode;
    },
    cncTelephone() {
      return this.$store.state.configs.cnc_telephone;
    },
    isRegisteringUser() {
      return this.$route.name == "Registration";
    },
  },
  methods: {
    goToNextStep() {
      this.$emit("valid-user-info");
    },
  },
};
</script>